/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-03 09:00:04
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {UserConfigDOI} from "./api/userConfigApi";
import UserConfigService from "./service/userConfigService";
import './userConfig.less';

@Component({name: 'user-config'})
export default class UserConfig extends BasicSearchPage<UserConfigService, UserConfigDOI.RowDataI, UserConfigDOI.QueryRowDataParamsI> {

    @override
    renderHead(h) {
        return <div></div>
    }
    
	@override
	loadService () {
		this.service = new UserConfigService(this)
	}
}